import { render } from "./ListEmpty.vue?vue&type=template&id=5b50ed90&scoped=true"
import script from "./ListEmpty.vue?vue&type=script&lang=js"
export * from "./ListEmpty.vue?vue&type=script&lang=js"

import "./ListEmpty.vue?vue&type=style&index=0&id=5b50ed90&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b50ed90"]])

export default __exports__